/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_CustomInputs */

const en_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Region`)
};

const fr_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Région personnalisée`)
};

const de_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Region`)
};

const it_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione personalizzata`)
};

const ru_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательский регион`)
};

const es_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Región personalizada`)
};

const zh_cn2_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义区域`)
};

const ja_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムリージョン`)
};

const hi_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम क्षेत्र`)
};

const pt_pt2_ocr_crop_custom = /** @type {(inputs: Ocr_Crop_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Região personalizada`)
};

/**
* | output |
* | --- |
* | "Custom Region" |
*
* @param {Ocr_Crop_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_custom = /** @type {((inputs?: Ocr_Crop_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_custom(inputs)
	if (locale === "de") return de_ocr_crop_custom(inputs)
	if (locale === "it") return it_ocr_crop_custom(inputs)
	if (locale === "ru") return ru_ocr_crop_custom(inputs)
	if (locale === "es") return es_ocr_crop_custom(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_custom(inputs)
	if (locale === "ja") return ja_ocr_crop_custom(inputs)
	if (locale === "hi") return hi_ocr_crop_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_custom(inputs)
	return en_ocr_crop_custom(inputs)
});